import * as React from 'react';
import Box from '@mui/material/Stack';

import Bs4Kartoteka from '../Bs4Kartoteka';

export default function Bs4CriteriaSummary(props) {  
  const option = React.useMemo(() => {
    const bs4Kartoteka = Bs4Kartoteka.get(props.bs4KartotekaId);
    const bs4Option = bs4Kartoteka.getBs4Option(props.optionId);
    return bs4Option;
  }, []);

  if (props.hidden || option.bs4Form.getFields() < 1) return null;

  // console.log('...CriteriaSummary Chip...');

  return (
    <Box sx={{display:"flex", flexDirection:"row", flexWrap:'wrap', gap:1, alignItems:'center', p:0}}>
      {[...option.bs4Form.getFields()].map(field => {
        return <field.ViewChip key={field.inputId}/>
      })}
    </Box>
  );
}